      <ul class="grid" data-digital{{{ root }}}>
{{#each items}}
        <li class="card card--ai reveal"{{{ edit }}}>
          <a href="{{ full }}" data-digital-hit>
            <span class="card-media">
              {{{ img }}}
              <span class="ai-badge" lang="en">AI</span>
            </span>
            <span class="card-meta"><span class="card-cat"{{{ cat.attrs }}}>{{{ cat.html }}}</span><span class="card-year">{{ year }}</span></span>
            <h3 class="card-title"{{{ title.attrs }}}>{{{ title.html }}}</h3>
            <p class="card-desc"{{{ desc.attrs }}}>{{{ desc.html }}}</p>
          </a>
        </li>
{{/each}}
      </ul>
